import * as ActionTypes from '../../../constants/setting/blog'
import update from 'immutability-helper'

const initialState = {
}

export default (state = initialState, action) => {
	switch(action.type) {
		case ActionTypes.RECEIVE_SETTINGS:
			return action.settings.address

    case ActionTypes.CHANGE_SLOGAN_ADDRESS:
      return update(state, {
        useSlogan: {
					$set: action.slogan
				}
      })

    case ActionTypes.CHANGE_CUSTOM_DOMAIN:
      return update(state, {
        secondaryDomain: {
          $set:action.customDomain
        },
        certStatus: {
          $set:action.certStatus
        },
        useSecondaryDomain: {
          $set:true
        }
      })

    case ActionTypes.CHANGE_CUSTOM_DOMAIN_CERT_STATUS:
      return update(state, {
        certStatus: {
          $set:action.certStatus
        },
        certExpireDate: {
          $set:action.expireDate
        }
      })

    case ActionTypes.CHANGE_CUSTOM_DOMAIN_DNS_FAIL:
      return update(state, {
        dnsFailDetected: {
          $set:action.dnsFail
        }
      })

    case ActionTypes.DELETE_CUSTOM_DOMAIN:

      return update(state, {
        secondaryDomain: {
          $set:action.customDomain
        },
        useSecondaryDomain: {
          $set:action.useSecondaryDomain
        },
        certStatus : {
          $set: action.certStatus
        },
        dnsFailDetected : {
          $set: action.dnsFailDetected
        },
        certExpireDate : {
          $set: action.certExpireDate
        }
      })
		default:
			return state
	}
}
